// Feature flag: enable AJAX navigation by default (asset dedupe and CE guards are in place)
if (typeof window.__ENABLE_AJAX_NAV__ === 'undefined') {
  window.__ENABLE_AJAX_NAV__ = true;
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// Prevent duplicate custom element definition errors from third-party/app scripts
(function(){
  if (!window.__CE_DEFINE_GUARD__) {
    window.__CE_DEFINE_GUARD__ = true;
    try {
      const originalDefine = window.customElements && window.customElements.define ? window.customElements.define.bind(window.customElements) : null;
      if (originalDefine) {
        window.customElements.define = function(name, ctor, options) {
          if (window.customElements.get(name)) {
            return; // already defined, ignore
          }
          return originalDefine(name, ctor, options);
        };
      }
    } catch(e) {}
  }
})();

// Guard against duplicate <script src=...> injections during SPA navigations
(function(){
  if (window.__SCRIPT_INJECTION_GUARD__) { return; }
  window.__SCRIPT_INJECTION_GUARD__ = true;
  try {
    const originalAppendChild = Node.prototype.appendChild;
    const originalInsertBefore = Node.prototype.insertBefore;
    const originalReplaceChild = Node.prototype.replaceChild;

    function maybeBlockScript(node) {
      try {
        if (!node || !node.tagName || node.tagName.toUpperCase() !== 'SCRIPT') return false;
        const src = node.getAttribute('src');
        if (!src) return false; // allow inline scripts
        if (isScriptAlreadyLoaded(src)) {
          return true; // block duplicate external scripts
        }
        markScriptLoaded(src); // record first time
        return false;
      } catch(e) {
        return false;
      }
    }

    Node.prototype.appendChild = function(node) {
      if (maybeBlockScript(node)) { return node; }
      return originalAppendChild.call(this, node);
    };

    Node.prototype.insertBefore = function(node, ref) {
      if (maybeBlockScript(node)) { return node; }
      return originalInsertBefore.call(this, node, ref);
    };

    Node.prototype.replaceChild = function(node, ref) {
      if (maybeBlockScript(node)) { return ref; }
      return originalReplaceChild.call(this, node, ref);
    };
  } catch(e) {}
})();

function rebindSummaryEvents() {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    if(summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  // summary.setAttribute('role', 'button');
  // summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      // [Platypus 2026-08-27] Guard: if pickup-availability.js has not run yet (see the
      // updatePage() note on script loading, LFD-21), this element has not upgraded and has no
      // methods. Skipping it here is better than throwing and aborting the rest of this handler.
      if (typeof pickUpAvailability.fetchAvailability === 'function') {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      }
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    // [Platypus 2026-08-27] Same guard as updatePickupAvailability() - see LFD-21.
    if (productForm && typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// 
// 
// 

// Function to load content via AJAX
function loadContent(url) {
  return fetch(url)
    .then(response => response.text())
    .then(data => {
      const parser = new DOMParser();
      const parsedHtml = parser.parseFromString(data, 'text/html');
      return { url: url, content: parsedHtml };
    })
    .catch(error => {
      console.error('Error:', error);
    });
}

// Function to load a JavaScript file
function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// Function to load a CSS file
function loadStylesheet(href) {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = resolve;
    link.onerror = reject;
    document.head.appendChild(link);
  });
}

function getFileNameFromUrl(urlString) {
  try {
    const u = new URL(urlString, window.location.origin);
    const path = u.pathname || '';
    return path.substring(path.lastIndexOf('/') + 1);
  } catch(e) {
    return urlString;
  }
}

if (!window.__ASSET_TRACKER__) {
  window.__ASSET_TRACKER__ = { scripts: {}, styles: {} };
}

function markScriptLoaded(url) {
  window.__ASSET_TRACKER__.scripts[getFileNameFromUrl(url)] = true;
}

function markStyleLoaded(url) {
  window.__ASSET_TRACKER__.styles[getFileNameFromUrl(url)] = true;
}

function isScriptAlreadyLoaded(src) {
  return !!window.__ASSET_TRACKER__.scripts[getFileNameFromUrl(src)];
}

function isStylesheetAlreadyLoaded(href) {
  // [Platypus 2026-08-26] This used to trust __ASSET_TRACKER__ alone. Shopify emits section
  // stylesheets INSIDE #MainContent, and updatePage() replaces that element wholesale — so the
  // tag was destroyed while the tracker still reported it loaded. component-card.css then went
  // missing after every navigation, product cards lost their layout, and their images rendered
  // at 0x0. A reload cleared the tracker, which is why refreshing "fixed" it.
  // A stylesheet now counts as loaded only if its tag is still in the document AND sits outside
  // #MainContent, i.e. it will survive the swap.
  var name = getFileNameFromUrl(href);
  var main = document.getElementById('MainContent');
  var links = document.querySelectorAll('link[rel="stylesheet"][href]');
  for (var i = 0; i < links.length; i++) {
    if (getFileNameFromUrl(links[i].href) !== name) continue;
    if (!main || !main.contains(links[i])) return true;
  }
  return false;
}

function seedAssetTracker() {
  try {
    Array.from(document.querySelectorAll('script[src]')).forEach(s => markScriptLoaded(s.src));
    Array.from(document.querySelectorAll('link[rel="stylesheet"][href]')).forEach(l => markStyleLoaded(l.href));
  } catch(e) {}
}

seedAssetTracker();

// Function to execute inline scripts in order
async function executeInlineScripts(inlineScripts) {
  const totalScripts = inlineScripts.length;
  let count = 0;

  if (totalScripts === 0) {
    return Promise.resolve();
  }

  for (const script of inlineScripts) {
    try {
      await new Promise((resolve) => {
        const newScript = document.createElement('script');
        newScript.innerHTML = script.innerHTML;
        newScript.onload = resolve;
        document.body.appendChild(newScript);
      });
    } catch (error) {
      console.error('Error executing script:', error);
    }
    count++;
  }

  if (count === totalScripts) {
    return Promise.resolve();
  }
}

// Function to preload images
function preloadImages(images) {
  const imagePromises = Array.from(images).map(image => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = image.src;
      img.onload = resolve;
      img.onerror = reject;
    });
  });

  return imagePromises;
}


// Function to update the page content
function updatePage(content) {
  const newDoc = content.content;
  const newMain = newDoc.querySelector('#MainContent');
  const currentMain = document.querySelector('#MainContent');

  // Determine where to scan for assets
  const scanRoot = newMain || (newDoc.body ? newDoc.body : null);
  const stylesheetTags = Array.from(scanRoot ? scanRoot.querySelectorAll('link[rel="stylesheet"][href]') : []);

  // Prepare sanitized HTML (remove script/link tags to avoid re-execution by third parties)
  // [Platypus 2026-08-27] script[type="application/json"] is kept: it carries no executable code,
  // only each product's variant data (read by VariantSelects/VariantRadios.getVariantData()).
  // Removing it made every size/variant click on an internally-navigated product page fail
  // silently and leave the add-to-cart form pointed at the first variant. See LFD-21.
  let sanitizedHTML = '';
  if (newMain) {
    const clone = newMain.cloneNode(true);
    clone.querySelectorAll('script:not([type="application/json"]), link[rel="stylesheet"]').forEach(n => n.remove());
    sanitizedHTML = clone.innerHTML;
  } else if (newDoc.body) {
    const cloneBody = newDoc.body.cloneNode(true);
    cloneBody.querySelectorAll('script:not([type="application/json"]), link[rel="stylesheet"]').forEach(n => n.remove());
    sanitizedHTML = cloneBody.innerHTML;
  }

  // Load any missing page-specific external assets (deduped by filename)
  // [Platypus 2026-08-27] This used to be hard-disabled ("do not load any scripts during SPA
  // updates, to avoid duplicate declarations"). That is a real risk for a script already loaded
  // on the previous page (customElements.define throws if called twice for the same tag), but it
  // is not a risk for one that was never loaded yet - and skipping those unconditionally meant
  // product-form.js and pickup-availability.js never ran on the first product page reached by an
  // in-site click, so <product-form> and <pickup-availability> stayed plain, method-less
  // elements. That aborted onVariantChange() with "X is not a function" before it reached the
  // line that updates the add-to-cart form's variant id - see LFD-21. Deduping by filename, the
  // same way stylesheets just below already do safely, loads each script at most once.
  const scriptTags = Array.from(scanRoot ? scanRoot.querySelectorAll('script[src]') : []);

  const scriptPromises = scriptTags
    .filter((s) => !isScriptAlreadyLoaded(s.src))
    .map((s) => loadScript(s.src).then(() => markScriptLoaded(s.src)).catch(() => markScriptLoaded(s.src)));

  const stylesheetPromises = stylesheetTags
    .filter((l) => !isStylesheetAlreadyLoaded(l.href))
    .map((l) => loadStylesheet(l.href).then(() => markStyleLoaded(l.href)).catch(() => markStyleLoaded(l.href)));

  return Promise.all([...scriptPromises, ...stylesheetPromises]).then(() => {
    // [Platypus 2026-08-26] Move any stylesheet tag living inside #MainContent up into <head>
    // before the swap, so it survives instead of being destroyed with the old markup.
    if (currentMain) {
      currentMain.querySelectorAll('link[rel="stylesheet"][href]')
        .forEach(function (l) { try { document.head.appendChild(l); } catch (e) {} });
    }
    if (currentMain && sanitizedHTML) {
      currentMain.innerHTML = sanitizedHTML;
      window.__LFD_PAGE_SWAPPED__ = true;   // [Platypus] tells runadditionalscripts a real swap occurred
    } else if (sanitizedHTML) {
      document.querySelector('body').innerHTML = sanitizedHTML;
    }

    const newTitleEl = newDoc.querySelector('title');
    if (newTitleEl) {
      document.title = newTitleEl.innerHTML;
    }

    try { rebindSummaryEvents(); } catch(e) { /* noop */ }
    try { setTimeout(function(){ if (typeof runadditionalscripts === 'function') { runadditionalscripts(); } }, 1000); } catch(e) { /* noop */ }
  });
}


// [Platypus 2026-08-26] The router cancels the real navigation and swaps #MainContent only.
// The header is never replaced, so the mobile menu drawer stayed open on top of the new page —
// which reads as "nothing happened", and while it is open the body is scroll-locked, so lazy
// images below the fold are never reached and never load. Closing it restores both.
function closeHeaderMenus() {
  try {
    var drawer = document.getElementById('Details-menu-drawer-container');
    if (drawer && drawer.hasAttribute('open')) {
      drawer.removeAttribute('open');
      var s = drawer.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    }
    document.querySelectorAll('header details[open], .header details[open]')
      .forEach(function (el) { el.removeAttribute('open'); });
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
  } catch (e) { /* never let this stop navigation */ }
}

// Handle navigation and link clicks
document.addEventListener('click', event => {
  if (!window.__ENABLE_AJAX_NAV__) {
    return; // allow normal navigation
  }
  const target = event.target.closest('a');
  if (target && target.href.startsWith(window.location.origin)) {
    event.preventDefault();
    closeHeaderMenus();
    const url = new URL(target.href);

    if (url.href === 'https://lfillede.com/') {
      // Clear the URL
      window.history.pushState(null, '', '/');
    } else {
      // Append the URL to the current URL without reloading the page
      window.history.pushState(null, '', url.href);
    }

    // Load the content via AJAX
    loadContent(url.href)
      .then(content => {
        // Scroll to top before updating page content
        window.scrollTo(0, 0);
        return updatePage(content);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
  
  setTimeout(function() {
    runadditionalscripts();
  }, 1000);
});



// Handle back/forward navigation
window.addEventListener('popstate', () => {
  if (!window.__ENABLE_AJAX_NAV__) {
    return;
  }
  const url = window.location.href;
  loadContent(url)
    .then(content => {
      // Scroll to top before updating page content
      window.scrollTo(0, 0);
      return updatePage(content);
    })
    .catch(error => {
      console.error('Error:', error);
    });
});

// Handle initial page load
window.addEventListener('DOMContentLoaded', () => {
    setTimeout(function() {
    	runadditionalscripts();
    }, 1000);
});


// Additional Scripts
let runadditionalscripts = () => {

// [Platypus 2026-08-26] Removed: window.onbeforeunload = () => window.scrollTo(0, 0);
// It made the browser show "Leave site? Changes you made may not be saved" on every
// page, and blocked navigation. Scroll-to-top is already handled inside loadContent().

// [Platypus 2026-08-26] Rebuilding the payment button is only needed after the router has
// actually swapped the page. runadditionalscripts() also runs 1s after every page load and
// again on EVERY click, so this block was tearing down and re-creating the Buy-it-now button
// constantly - which is the flicker. It now runs only when a swap really happened.
if (window.__LFD_PAGE_SWAPPED__) {
  window.__LFD_PAGE_SWAPPED__ = false;

  // Reinitialize Shopify payment buttons after AJAX load
  if (window.Shopify && window.Shopify.PaymentButton) {
    window.Shopify.PaymentButton.init();
  }

// Force reinitialize all Shopify web components
document.querySelectorAll('shopify-accelerated-checkout, shopify-buy-it-now-button').forEach(element => {
  // Disconnect and reconnect to trigger reinitialization
  if (element.disconnectedCallback) {
    element.disconnectedCallback();
  }
  if (element.connectedCallback) {
    element.connectedCallback();
  }
});

// Alternative: Force re-render by cloning elements
document.querySelectorAll('[data-shopify="payment-button"]').forEach(container => {
  const clone = container.cloneNode(true);
  container.parentNode.replaceChild(clone, container);
});
} // end of the post-swap-only block

 // Initialize Simple Bundles Choices.js selects
function initializeSimpleBundleSelects() {
  const selects = document.querySelectorAll('#simple-bundles-io-options select');

  selects.forEach(select => {
    if (select.dataset.choicesInitialized) return;

    // Check if Choices is available
    if (typeof Choices === 'undefined') {
      console.warn('Choices.js not loaded yet, retrying...');
      setTimeout(initializeSimpleBundleSelects, 100);
      return;
    }

    const instance = new Choices(select, {
      searchEnabled: false,
      itemSelectText: '',
      shouldSort: false,
      allowHTML: false
    });

    // Add extra class safely
    instance.containerOuter.element.classList.add('simple-bundle-choices');

    select.dataset.choicesInitialized = 'true';
  });
}

// Enhanced initialization with user interaction triggers
function initializeSimpleBundlesWithInteraction() {
  // Try immediate initialization
  initializeSimpleBundleSelects();
  
  // Add event listeners for user interactions that seem to trigger the Simple Bundles loading
  const events = ['click', 'mouseover', 'focus', 'scroll', 'touchstart'];
  
  events.forEach(eventType => {
    document.addEventListener(eventType, function initOnInteraction() {
      setTimeout(() => {
        initializeSimpleBundleSelects();
      }, 50);
    }, { once: false, passive: true });
  });
  
  // Also try on window load and various other events
  window.addEventListener('load', () => {
    setTimeout(initializeSimpleBundleSelects, 100);
  });
  
  // Try on DOM changes
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => {
      setTimeout(initializeSimpleBundleSelects, 50);
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'id']
    });
  }
  
  // Periodic check as fallback
  setInterval(() => {
    const uninitializedSelects = document.querySelectorAll('#simple-bundles-io-options select:not([data-choices-initialized])');
    if (uninitializedSelects.length > 0) {
      initializeSimpleBundleSelects();
    }
  }, 1000);
}

// Call the enhanced function to initialize Simple Bundle selects
initializeSimpleBundlesWithInteraction();

// Handle bundle products - change "Add to cart" to "Choose options" for bundle products
function updateBundleProductButtons() {
  // Method 1: Check for products with bundle-related tags or metafields
  document.querySelectorAll('.quick-add__submit').forEach(button => {
    const productCard = button.closest('.card-wrapper');
    if (!productCard) return;
    
    const productLink = productCard.querySelector('a[href*="/products/"]');
    if (!productLink) return;
    
    const productUrl = productLink.getAttribute('href');
    const productHandle = productUrl.split('/products/')[1]?.split('?')[0];
    
    // Check if this is a known bundle product (you can add more handles here)
    const bundleProducts = ['the-kit', 'de-kit']; // Add your bundle product handles here
    
    if (bundleProducts.includes(productHandle)) {
      const buttonText = button.querySelector('span');
      if (buttonText && buttonText.textContent.trim() === 'Add to cart') {
        buttonText.textContent = 'Choose options';
        
        // Convert the form submission to a page navigation
        button.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          
          // Navigate to product page instead of adding to cart
          if (window.__ENABLE_AJAX_NAV__) {
            loadContent(productUrl)
              .then(content => {
                // Scroll to top before updating page content
                window.scrollTo(0, 0);
                return updatePage(content);
              })
              .catch(error => {
                console.error('Error:', error);
                window.location.href = productUrl; // Fallback to normal navigation
              });
          } else {
            window.location.href = productUrl;
          }
        });
      }
    }
  });
  
  // Method 2: Check for Simple Bundles app indicators
  document.querySelectorAll('.quick-add__submit').forEach(button => {
    const productCard = button.closest('.card-wrapper');
    if (!productCard) return;
    
    // Look for bundle indicators in the product data or DOM
    const productTitle = productCard.querySelector('.card__heading a');
    if (productTitle && productTitle.textContent.toLowerCase().includes('kit')) {
      const buttonText = button.querySelector('span');
      if (buttonText && buttonText.textContent.trim() === 'Add to cart') {
        buttonText.textContent = 'Choose options';
        
        const productUrl = productTitle.getAttribute('href');
        button.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          
          if (window.__ENABLE_AJAX_NAV__) {
            loadContent(productUrl)
              .then(content => {
                // Scroll to top before updating page content
                window.scrollTo(0, 0);
                return updatePage(content);
              })
              .catch(error => {
                console.error('Error:', error);
                window.location.href = productUrl;
              });
          } else {
            window.location.href = productUrl;
          }
        });
      }
    }
  });
}

// Call the function to update bundle product buttons
updateBundleProductButtons();

(function() {
      if (window.soldOutBadgeInitialized) return;
      window.soldOutBadgeInitialized = true;
      
      function updateSoldOutBadges(variant) {
        const soldOutBadges = document.querySelectorAll('[data-sold-out-badge]');
        soldOutBadges.forEach(badge => {
          if (variant && variant.available) {
            badge.style.display = 'none';
          } else {
            badge.style.display = '';
          }
        });
      }
      
      // Wait for pubsub to be available
      function initSubscription() {
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            updateSoldOutBadges(event.data.variant);
          });
        } else {
          setTimeout(initSubscription, 100);
        }
      }
      
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSubscription);
      } else {
        initSubscription();
      }
    })();


if(document.querySelectorAll('.product__accordion') !== null) {
document.querySelectorAll('.product__accordion').forEach((i) => {
if(i.querySelector('.accordion__content p') == null) {
i.remove();
}
})
}


if(document.querySelector(".customcolor") != null) {
	
document.querySelector(".customcolor").style.backgroundColor = document.querySelector(".customcolor").dataset.color;
}

if(document.querySelector("#Details-HeaderMenu-3")) {

document.querySelector("#Details-HeaderMenu-3").addEventListener("mouseover", () => {
document.querySelector("#Details-HeaderMenu-3").setAttribute("open","");
})

document.querySelector("#Details-HeaderMenu-3").addEventListener("mouseout", () => {
document.querySelector("#Details-HeaderMenu-3").removeAttribute('open')
})

document.querySelector("#Details-HeaderMenu-3 > summary").addEventListener("click", () => {
  // Make an AJAX request to the desired URL
  loadContent("https://lfillede.com/collections/de-bride-collection")
    .then(content => {
      // Scroll to top before updating page content
      window.scrollTo(0, 0);
      return updatePage(content);
    })
    .catch(error => {
      console.error('Error:', error);
    });
});

}

if(document.querySelector(".custom_prices") !== null) {

let newcustomprice = document.querySelector(".custom_prices").cloneNode(true);

var __kitSlideHeading = document.querySelector('li[id^="Slide-template--"][id$="__37761855-3176-4d22-8f44-468aa394323a-1"] h3');
// [Platypus 2026-08-26] Was a hardcoded `template--19254137782575__` prefix. Shopify generates that
// number per theme, so it changed the moment the theme was copied, querySelector returned null, and
// .append() threw — killing runadditionalscripts and everything after it. Matched by stable suffix now,
// and guarded so a miss can never take the rest of the function down with it.
if (__kitSlideHeading) { __kitSlideHeading.append(newcustomprice); }

}

if(document.querySelector('[id^="quick-add-template--"][id$="__featured-collection8317728457007-submit"] span') !== null) {

document.querySelector('[id^="quick-add-template--"][id$="__featured-collection8317728457007-submit"] span').innerText = "Choose kit options";

}

if(document.querySelector('.collection [id^="quick-add-template--"][id$="__featured-collection8317728457007-submit"]') !== null) {
  
document.querySelector('.collection [id^="quick-add-template--"][id$="__featured-collection8317728457007-submit"]').addEventListener("click", function(event) {
  event.preventDefault(); // Prevent form submission
  
  loadContent("https://lfillede.com/products/the-kit")
    .then(content => {
      // Scroll to top before updating page content
      window.scrollTo(0, 0);
      return updatePage(content);
    })
    .catch(error => {
      console.error('Error:', error);
    });
});

}

     ['header', 'nav', 'footer'].forEach(tagName => {
        Array.from(document.getElementsByTagName(tagName)).forEach(element => {
            if (element.hasAttribute('tabindex')) {
                element.removeAttribute('tabindex');
            }
        });
    }); 

    if(document.querySelector('.sizepopup button')) {
    	document.querySelector('.sizepopup button').addEventListener("click", () => {
    		document.querySelector('.sizepopup').style.setProperty('display', 'none', 'important');
    	})
    }

    
if (document.querySelector("product-info[data-url='/products/de-one-piece-black']")) {
    var __sizeTriggerblack = document.querySelector('product-info[data-url="/products/de-one-piece-black"] [id^="Details-343e5e84-0734-492c-a036-915b67fbe860-template--"][id$="__main"] .metafield-multi_line_text_field');
    if (__sizeTriggerblack) __sizeTriggerblack.addEventListener("click", () => {
        document.querySelector('.sizepopup').style.setProperty('display', 'flex', 'important');
    });
}

if (document.querySelector("product-info[data-url='/products/de-one-piece-white']")) {
    var __sizeTriggerwhite = document.querySelector('product-info[data-url="/products/de-one-piece-white"] [id^="Details-343e5e84-0734-492c-a036-915b67fbe860-template--"][id$="__main"] .metafield-multi_line_text_field');
    if (__sizeTriggerwhite) __sizeTriggerwhite.addEventListener("click", () => {
        document.querySelector('.sizepopup').style.setProperty('display', 'flex', 'important');
    });
}


if(document.querySelector('.product-media-container video')) {
  document.querySelector('.product-media-container video').controls = false;
  document.querySelector("button[aria-label*='video']").addEventListener("click", () => {
    document.querySelector('.product-media-container video').play();
  })
}

const addtocartpaymentbtns = document.querySelectorAll(
  ".product-form__submit, .shopify-payment-button button"
);

if (!addtocartpaymentbtns.length) return;

addtocartpaymentbtns.forEach((btn) => {
  btn.addEventListener("click", () => {
  !function(){var e=document.getElementById("simple-bundles-io-options").querySelectorAll("select"),t=document.querySelectorAll('form[action*="cart/Add" i]');function n(e,n){for(var i=0;i<t.length;i++){var r=t[i].querySelector('input[name="'+e+'"].simple-bundles-infinite-option-prop');if(r)r.value=n;else{var o=document.createElement("input");o.type="hidden",o.className="simple-bundles-infinite-option-prop",o.name=e,o.value=n,t[i].appendChild(o)}}}function i(){var t=[],i=[],r=window.SimpleBundles&&window.SimpleBundles.currentProductVariant&&window.SimpleBundles.currentProductVariant.variant_options_v2;(r&&r.forEach((function(e){e.forEach((function(t,n){i.push(e.length>1&&n!==e.length-1?" ++ ":" <> ")}))})),0!==e.length)&&(e.forEach((function(n,r){t.push(n.value),r!==e.length-1&&t.push(i[r]||" <> ")})),0!==t.length&&n("properties[_bundle_selection]",t.join("")))}function r(e){const t=Array.from(e.querySelectorAll("option:not([disabled])"));t.sort(((e,t)=>(parseFloat(e.getAttribute("data-price-diff"))||0)-(parseFloat(t.getAttribute("data-price-diff"))||0)));const n=e.querySelector("option[disabled]");e.innerHTML="",n&&e.appendChild(n),t.forEach((t=>{e.appendChild(t)})),t.length>0&&(t[0].selected=!0)}!function(){window.SimpleBundles&&window.SimpleBundles.settings&&window.SimpleBundles.settings.showPriceVariance&&(function(){for(var t=0;t<e.length;t++)Array.from(e[t].options).forEach((function(e){if(e.disabled)return;const t=parseFloat(e.getAttribute("data-price-diff")),n=e.getAttribute("data-price-displayed");if(t&&0!==t&&!n){var i=Math.abs(t);if(window.Shopify?.currency?.rate){const e=parseFloat(window.Shopify.currency.rate);isNaN(e)||1===e||(i*=e)}const n=window.SimpleBundles.currencyFormatter.format(i);var r=t>0?" (+"+n+")":" (-"+n+")";e.textContent=e.textContent+r,e.setAttribute("data-price-displayed","true")}}))}(),window.SimpleBundles.settings.rankOptionsByPriceDiff&&function(){for(var t=0;t<e.length;t++)Array.from(e[t].options).some((e=>parseFloat(e.dataset.priceDiff)>0))&&r(e[t])}());for(var t=0;t<e.length;t++)e[t].addEventListener("change",(function(){n(this.name,this.value),i()})),n(e[t].name,e[t].value);i()}()}();
  });
});

}